import { useQuery } from '@tanstack/react-query';
import type { SeriesTypeDto } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface CatalogueTypesApiResponse {
  success: boolean;
  data: SeriesTypeDto[];
}

/**
 * Hook to fetch all types for a given catalogue series.
 * Calls GET /catalogue/series/:id/types.
 * Disabled until a valid seriesId is provided (cascade selector pattern).
 */
export function useCatalogueTypes(seriesId: number | undefined, windowTypeId?: number) {
  return useQuery({
    queryKey: queryKeys.catalogue.types(seriesId ?? 0, windowTypeId),
    queryFn: async () => {
      const params = windowTypeId ? { windowTypeId } : undefined;
      const response = await apiClient.get<CatalogueTypesApiResponse>(
        `/catalogue/series/${seriesId}/types`,
        { params }
      );
      return response.data.data;
    },
    enabled: seriesId != null && seriesId > 0,
    staleTime: 5 * 60 * 1000,
  });
}
